__turbopack_context__.v({
  "container": "nV8N-a_container",
  "content": "nV8N-a_content",
  "shimmer": "nV8N-a_shimmer",
  "text-bar-sweep": "nV8N-a_text-bar-sweep",
  "title": "nV8N-a_title",
  "title__placeholder": "nV8N-a_title__placeholder",
});
